import React, { ReactNode } from 'react';
import { FormInstance, FormItemProps, SpaceProps } from "antd";

export type Properties = { [property: string]: any };
export type Component<T extends string = string> = JSX.Element | React.ReactElement<T>;
export type ComponentOrComponentConfigMap<P extends Properties, K extends keyof P = keyof P, O = undefined> = Component<P[K]> | ComponentConfigsMap<P[K], O>;
export type ValueOrFunction<T, P extends Properties, O = undefined> = T | ((properties: P, optional: O | undefined, form: FormInstance<P>) => T)

/** Used for mapping properties from an object to react components */
export type ComponentConfigsMap<P extends Properties, O = undefined> = {
    [K in keyof P]?: ComponentConfig<P, K, O>
};

export interface ComponentConfig<P extends Properties, K extends keyof P = keyof P, O = undefined> {
    label?: ValueOrFunction<string, P, O>,
    hidden?: ValueOrFunction<boolean, P, O>,
    delay?: number,
    formItem?: FormItemProps<P>,    
    component: ValueOrFunction<ComponentOrComponentConfigMap<P, K, O>, P, O>,
    /** Only nested properties. */
    group?: SpaceProps,
    before?: ValueOrFunction<ReactNode, P, O>,
    after?: ValueOrFunction<ReactNode, P, O>
}

export function extractValueOrFunction<T, P extends Properties, O = undefined>(
    valueOrFunction: ValueOrFunction<T, P, O>,
    properties: P,
    optional: O | undefined,
    form: FormInstance<P>
) {
    if (valueOrFunction instanceof Function)
        return valueOrFunction(properties, optional, form);
    else
        return valueOrFunction;
}
